import tippy from './../../../node_modules/tippy.js';
import './../../../node_modules/tippy.js/dist/tippy.css';

window.tippy = tippy;

window.tippyLinkScript = () => {
  window.tippy('[data-tippy-template]', {
    content(reference) {
      const id = reference.querySelector("a[data-state]").getAttribute('data-state');

      if (!id) {
        return false;
      }

      return document.getElementById('tippy_container_' + id).innerHTML;
    },
    allowHTML: true,
    interactive: true,
  });
};

